import React from "react";

const profileFeatureContext = React.createContext("");
export default profileFeatureContext;
